import { render } from "./DefaultInput.vue?vue&type=template&id=57b235e1"
import script from "./DefaultInput.vue?vue&type=script&lang=js"
export * from "./DefaultInput.vue?vue&type=script&lang=js"
script.render = render

export default script